import { createContext } from 'react'

const pluginContext = createContext()

export default pluginContext
